import { Plus, Copy, Wand2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

export interface GridFooterActionsProps {
  isReadOnly: boolean;
  enableCopyPreviousWeek: boolean;
  enableAutoSmartFill: boolean;
  onAddRow: () => void;
  onCopyLastWeek: () => void;
  onOpenAutoFill: () => void;
}

/** Footer cell holding the Add Row, Copy Last Week and Smart Auto-Fill buttons. */
export function GridFooterActions({
  isReadOnly,
  enableCopyPreviousWeek,
  enableAutoSmartFill,
  onAddRow,
  onCopyLastWeek,
  onOpenAutoFill,
}: GridFooterActionsProps) {
  return (
    <td className="p-2 sm:p-2.5">
      {!isReadOnly && (
        <div className="flex items-center gap-1.5">
          <Button
            onClick={onAddRow}
            variant="outline"
            size="default"
            className="gap-1.5"
            title="Add a new timesheet row (Alt+A)"
            data-tour="timesheet-add-row"
          >
            <Plus className="h-4 w-4" />
            Add Row
          </Button>
          {enableCopyPreviousWeek && (
            <Button
              onClick={onCopyLastWeek}
              variant="outline"
              size="default"
              className="gap-1.5"
            >
              <Copy className="h-4 w-4" />
              Copy Last Week
            </Button>
          )}
          {enableAutoSmartFill && (
            <Button
              onClick={onOpenAutoFill}
              variant="outline"
              size="default"
              className="gap-1.5"
            >
              <Wand2 className="h-4 w-4" />
              Smart Auto-Fill
            </Button>
          )}
        </div>
      )}
    </td>
  );
}
